import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import Keycloak from 'keycloak-js';
import {
  GroupControllerService,
} from '@mobiletract/auth-service-angular-client';
import type { KeycloakGroupSummaryResponse } from '@mobiletract/auth-service-angular-client';
import { Observable, of } from 'rxjs';
import { map, shareReplay, take, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PackageDisplayService {

  private displayNameMap: Record<string, string> = {};
  private load$: Observable<KeycloakGroupSummaryResponse[]>;

  constructor(
    private readonly keycloakService: KeycloakService,
    private readonly groupControllerService: GroupControllerService
  ) {
    this.load$ = this.groupControllerService.getGroups1('body').pipe(
      take(1),
      tap((response) => {
        const list = response ?? [];
        list.forEach((g) => {
          this.displayNameMap[g.name] = g.displayName ?? g.name;
        });
      }),
      shareReplay(1)
    );
  }

  private get keycloak(): Keycloak {
    return this.keycloakService.getKeycloakInstance();
  }

  isLoggedIn(): boolean {
    return this.keycloak.authenticated ?? false;
  }

  getPackageDisplayName$(): Observable<string | null> {
    if (Object.keys(this.displayNameMap).length > 0) {
      return of(this.resolveDisplayName());
    }
    return this.load$.pipe(
      map(() => this.resolveDisplayName())
    );
  }

  private resolveDisplayName(): string {
    const token = this.keycloak.tokenParsed as { groups?: string[] } | undefined;
    const groups: string[] = token?.groups ?? [];
    for (const group of groups) {
      const path = group.startsWith('/') ? group : `/${group}`;
      const name = path.slice(1);
      const displayName = this.displayNameMap[name];
      if (displayName) return displayName;
    }
    return '';
  }
}
